import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {BlogEntryDTO} from "../../../DTO/BlogEntryDTO";

interface Project {
    id: number;
    name: string;
}

interface Props {
    onCreated: (entry?: BlogEntryDTO) => void;
}

const BlogCreateForm: React.FC<Props> = ({ onCreated }) => {
    const [title, setTitle] = useState('');
    const [slug, setSlug] = useState('');
    const [content, setContent] = useState('');
    const [publishDate, setPublishDate] = useState('');
    const [visible, setVisible] = useState(true);
    const [projectId, setProjectId] = useState<number | ''>('');
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get<Project[]>('/api/projects').then((res) => setProjects(res.data));
    }, []);

    const handleCreate = async () => {
        setLoading(true);
        try {
            const payload = { title, slug, content, publishDate, visible, projectId: projectId || null };
            const { data } = await axios.post<BlogEntryDTO>('/api/blog', payload);
            onCreated(data);
            setTitle('');
            setSlug('');
            setContent('');
            setPublishDate('');
            setVisible(true);
            setProjectId('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 bg-surface text-on-surface rounded shadow border border-border">
            <h2 className="text-xl font-semibold mb-4">Create Blog Post</h2>

            <input
                type="text"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="block mb-3 w-full border border-border rounded px-2 py-1 bg-background text-on-surface"
            />
            <input
                type="text"
                placeholder="Slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                className="block mb-3 w-full border border-border rounded px-2 py-1 bg-background text-on-surface"
            />
            <textarea
                placeholder="Content (Markdown supported)"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                className="block mb-3 w-full border border-border rounded px-2 py-1 bg-background text-on-surface h-32"
            />
            <input
                type="datetime-local"
                value={publishDate}
                onChange={(e) => setPublishDate(e.target.value)}
                className="block mb-3 w-full border border-border rounded px-2 py-1 bg-background text-on-surface"
            />
            <label className="block mb-3">
                <input
                    type="checkbox"
                    checked={visible}
                    onChange={(e) => setVisible(e.target.checked)}
                    className="mr-2"
                />
                Visible
            </label>

            <select
                value={projectId}
                onChange={(e) => setProjectId(e.target.value ? +e.target.value : '')}
                className="block mb-4 w-full border border-border rounded px-2 py-1 bg-background text-on-surface"
            >
                <option value="">No Project</option>
                {projects.map((p) => (
                    <option key={p.id} value={p.id}>
                        {p.name}
                    </option>
                ))}
            </select>

            <button
                onClick={handleCreate}
                disabled={loading}
                className="btn-primary"
            >
                {loading ? 'Creating…' : 'Create Blog Post'}
            </button>
        </div>
    );
};

export default BlogCreateForm;
